<aside id="sidebar_left" class="nano nano-light affix sidebar-default">
    <div class="sidebar-left-content nano-content" tabindex="0">
        <ul class="nav sidebar-menu allMenu">
            <li ng-if="can('maps')" ng-class="{ active: isActive(['map'])}">
                <a href="/map">
                    <i class="fa fa-map"></i>
                    <span class="sidebar-title">Map</span>
                </a>
            </li>

            <li ng-if="can('maps')" ng-class="{ active: isActive(['routes', 'routing', 'route-activity'])}">
                <!-- <a href="/routing"> -->
                <a href="/routes">
                    <i class="fa fa-map-signs"></i>
                    <span class="sidebar-title">Routes</span>
                </a>
            </li>

            <li ng-if="can('maps')" ng-class="{ active: isActive(['orders'])}">
                <a href="/orders">
                    <i class="fa fa-list"></i>
                    <span class="sidebar-title">Orders</span>
                </a>
            </li>

            <li ng-if="can('maps')" ng-class="{ active: isActive(['offers'])}">
                <a href="/offers">
                    <i class="fa fa-gift"></i>
                    <span class="sidebar-title">Offers</span>
                </a>
            </li>

            <!-- <li ng-if="can('maps')" ng-class="{ active: isActive(['blocks'])}">
                <a href="/blocks">
                    <i class="fa fa-calendar"></i>
                    <span class="sidebar-title">Blocks</span>
                </a>
            </li> -->
            

            <li ng-if="can('maps')" ng-class="{ active: isActive(['chats'])}">
                <a href="/chats">
                    <i class="fa fa-commenting-o"></i>
                    <span class="sidebar-title">
                        Chat
                        <div class="label label-danger" ng-if="messageCount > 0" style="border-radius: 50%;">
                            {{ messageCount }}
                        </div>
                    </span>
                </a>
            </li>

            <li ng-if="can('users')"
                ng-class="{ active: isActive(['calisan-yonetimi?type=truck','calisan-yonetimi?type=office','yeni-calisan?type=truck','yeni-calisan?type=office','ekip-yonetimi'])}">
                <a href="/calisan-yonetimi?type=truck">
                    <i class="fa fa-car"></i>
                    <span class="sidebar-title">Drivers</span>
                </a>
            </li>

            <li ng-if="can('reports')"
                ng-class="{ active: isActive(['earning'])}">
                <a href="/earning">
                    <i class="fa fa-money"></i>
                    <span class="sidebar-title">Earnings</span>
                </a>
            </li>

            <li ng-if="can('customers')" ng-class="{ active: isActive(['musteri-yonetimi'])}">
                <a href="/musteri-yonetimi">
                    <i class="fa fa-university"></i>
                    <span class="sidebar-title">Partners</span>
                </a>
            </li>

            <li ng-if="can('reports')"
                ng-class="{ active: isActive(['billing'])}">
                <a href="/billing">
                    <i class="fa fa-money"></i>
                    <span class="sidebar-title">Invoices</span>
                </a>
            </li>

            <li ng-if="can('users')" ng-class="{ active: isActive(['stations'])}">
                <a href="/stations">
                    <i class="fa fa-train"></i>
                    <span class="sidebar-title">Stations</span>
                </a>
            </li>
            

            <li ng-if="can('reports')"
                ng-class="{ active: isActive(['order-report','partner-report','invoice-reports', 'earning-reports', 'driver-reports'])}">
                <a href="/order-report">
                    <i class="fa fa-line-chart"></i>
                    <span class="sidebar-title">Reports</span>
                </a>
            </li>


            <!-- <li ng-if="can('maps')" ng-class="{ active: isActive(['gun-sonu'])}">
                <a href="/gun-sonu">
                    <i class="fa fa-money"></span>
                    <span class="sidebar-title">Gün Sonu</span>
                    <span class="caret"></span>
                </a>
            </li> -->
            <!-- <li ng-if="can('customer')" ng-class="{ active: isActive(['customer-tracking'])}">
                <a href="/customer-tracking">
                    <i class="fa fa-map"></span>
                    <span class="sidebar-title">Order Track</span>
                    <span class="caret"></span>
                </a>
            </li> -->
            <!-- <li ng-if="authenticatedUser.remaining_day < 15" class="active" >
                <a href="/satin-al" style="background:#f1703f !important">
                    <i class="fa fa-money" style="color:#fff !important"></span>
                    <span class="sidebar-title"> {{ authenticatedUser.remaining_day }} Gün Süreniz Kalmıştır!</span>
                    <span class="caret"></span>
                </a>
            </li> -->
            <!-- <li ng-if="can('reports')" ng-class="{ active: isActive(['gelir-gider'])}">
                <a href="/gelir-gider">
                    <i class="fa fa-money"></i>
                    <span class="sidebar-title">Income/Expense</span>
                </a>
            </li> -->
            <!-- <li ng-if="can('reports')" ng-class="{ active: isActive(['iade-teslim'])}">
                <a href="/iade-teslim">
                    <i class="fa fa-undo"></span>
                    <span class="sidebar-title">İade Teslim</span>
                    <span class="caret"></span>
                </a>
            </li> -->
            <li ng-if="can('settings')" ng-class="{ active: isActive(['profile', 'users', 'work-steps','change-password'])}">
                <a href="/profile">
                    <i class="fa fa-cogs"></i>
                    <span class="sidebar-title">Settings</span>
                </a>
            </li>
            <!-- <li ng-class="{ active: isActive('/customer-account')}">
                <a href="/customer-account">
                  i class="fa fa-building"></i>
                    <span>Şirket Bilgileri</span>
                </a>
            </li>
            
            <li ng-class="{ active: isActive('/customer-password')}">
                <a href="/customer-password">
                  i class="fa fa-key"></i>
                    <span>Şifre Değiştir</span>
                </a>
            </li> -->
            <!-- <li ng-class="{ active: isActive('/satin-al')}">
                <a href="/satin-al"> 
                  i class="fa fa-plus"></i> Kredi Yükle 
                </a>
            </li> -->
            <!-- <li style="padding: 0px;" ng-if="can('customer')">
                <a href="/customer-settings">
                    <i class="fa fa-cogs"></i>
                    <span class="sidebar-title">Settings</span>
                </a>
            </li> -->
            <li>
                <a href="#" ng-click="logout()">
                    <i class="fa fa-power-off"></i>
                    <span class="sidebar-title">Logout</span>
                </a>
            </li>
        </ul>
    </div>
</aside>